"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arraySum = void 0;
/**
 * sumuje wartości w tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function arraySum(array, prop) {
    if (prop) {
        return array.reduce((a, b) => a[prop] + b[prop], 0);
    }
    else {
        return array.reduce((a, b) => a + b, 0);
    }
}
exports.arraySum = arraySum;
//# sourceMappingURL=arraySum.js.map